"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpertVerification = exports.getExpertsVerifications = exports.getExpertNetworkEmails = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var getExpertNetworkEmails = function (expertId) {
    return api_1.default
        .get("".concat(process.env.REACT_APP_PLATFORM_2_API_URL, "/expert-network/email/getEmails?expertId=").concat(expertId, "&expertSourceFromLP=true"))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
};
exports.getExpertNetworkEmails = getExpertNetworkEmails;
var getExpertsVerifications = function (expertIds) {
    return api_1.default
        .post("".concat(process.env.REACT_APP_PLATFORM_2_API_URL, "/expert-network/expert/fetchExpertVerifications"), { lpUserIds: expertIds })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
};
exports.getExpertsVerifications = getExpertsVerifications;
var getExpertVerification = function (expertId) {
    return api_1.default
        .post("".concat(process.env.REACT_APP_PLATFORM_2_API_URL, "/expert-network/expert/fetchExpertVerifications"), { lpUserIds: [expertId] })
        .then(api_1.extractData)
        .then(function (data) { return (data === null || data === void 0 ? void 0 : data[0]) || null; })
        .catch(api_1.errorHandler);
};
exports.getExpertVerification = getExpertVerification;
